export const JAMS_PALETTE: Record<number, {color: string; border: string}> = {
  2: {color: '#333', border: '#000'},
  1: {color: '#b3b3b3', border: '#8e8e8e'},
  3: {color: '#47ca0b', border: '#2f8109'},
  4: {color: '#faff00', border: '#999c03'},
  5: {color: '#ff0003', border: '#9c0304'},
  6: {color: '#98201f', border: '#791918'},
}

export const LOAD_ROUTE_KEY = 'LOAD_ROUTE_KEY'
